import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { AuthService } from '@core/auth/auth.service';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { CustomBankAccountDrawerComponent } from '@shared/components/page-layout/drawers/custom-bank-account-drawer/custom-bank-account-drawer.component';
import { PageLayoutService } from '@shared/components/page-layout/page-layout.service';
import { BankAccountFieldProps } from '@shared/models/domain/custom-views.model';

@Component({
    selector: 'app-bank-account',
    templateUrl: './bank-account.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatButton, MatIcon]
})
export class BankAccountComponent extends FieldType<FieldTypeConfig<BankAccountFieldProps>> {
  private layoutService = inject(PageLayoutService);
  private authService = inject(AuthService);


  addNewBankAccount() {
    this.layoutService.navigateParentDrawer({
      component: CustomBankAccountDrawerComponent,
      smallDrawer: true,
      data: {
        userBankAccount: null,
        isCustomer: !(this.field?.props?.['isAdmin'] ?? false),
        userId: this.field?.props?.['userId'] ?? this.authService?.userProfile?.user?.id,
        userData: this.field?.props?.['userData'] ?? null,
      }
    });
  }
}
